export default __webpack_public_path__ + "static/ProcurementHero-dd84fa67dffc826711758b22bfea4bf4.png";